import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { usePaywall } from '../providers/PaywallProvider/PaywallProvider';

interface PaywallGuardProps {
  children: React.ReactNode;
  fallbackRoute?: string;
}

export const PaywallGuard: React.FC<PaywallGuardProps> = ({
  children,
  fallbackRoute = '/',
}) => {
  const router = useRouter();
  const { shouldPromptPaywall, isReady } = usePaywall();

  useEffect(() => {
    if (isReady && shouldPromptPaywall()) {
      // Extract tenantId from current route
      const tenantId = router.query.tenantId as string;

      // Redirect to the fallback route with tenantId
      if (tenantId) {
        router.replace(`/${tenantId}${fallbackRoute}`);
      } else {
        router.replace(fallbackRoute);
      }
    }
  }, [isReady, shouldPromptPaywall, router, fallbackRoute]);

  // If paywall should be prompted, don't render children
  // (they'll be redirected anyway)
  if (isReady && shouldPromptPaywall()) {
    return null;
  }

  // If not ready yet, render children (don't block)
  // If paywall shouldn't be prompted, render children normally
  return <>{children}</>;
};
